import { FC } from "react";
import Icon from ".";
import { IconElementProps, createIconVariantMap } from "./Icon.types";

export const Filled12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M5 1C2.79086 1 1 2.79086 1 5C1 7.20914 2.79086 9 5 9C5.92436 9 6.77548 8.68646 7.45282 8.15993L10.1464 10.8536C10.3417 11.0488 10.6583 11.0488 10.8536 10.8536C11.0488 10.6583 11.0488 10.3417 10.8536 10.1464L8.15993 7.45282C8.68646 6.77548 9 5.92436 9 5C9 2.79086 7.20914 1 5 1ZM2 5C2 3.34315 3.34315 2 5 2C6.65685 2 8 3.34315 8 5C8 6.65685 6.65685 8 5 8C3.34315 8 2 6.65685 2 5Z" fill="currentColor" />
    </svg>
  );
};

export const Filled16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M6.66671 1.33301C3.72119 1.33301 1.33337 3.72082 1.33337 6.66634C1.33337 9.61186 3.72119 11.9997 6.66671 11.9997C7.89918 11.9997 9.03401 11.5816 9.93714 10.8796L13.5286 14.4711C13.789 14.7314 14.2111 14.7314 14.4714 14.4711C14.7318 14.2107 14.7318 13.7886 14.4714 13.5283L10.8799 9.93677C11.582 9.03365 12 7.89881 12 6.66634C12 3.72082 9.61223 1.33301 6.66671 1.33301ZM2.66671 6.66634C2.66671 4.4572 4.45757 2.66634 6.66671 2.66634C8.87585 2.66634 10.6667 4.4572 10.6667 6.66634C10.6667 8.87548 8.87585 10.6663 6.66671 10.6663C4.45757 10.6663 2.66671 8.87548 2.66671 6.66634Z" fill="currentColor" />
    </svg>
  );
};

export const Filled20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M8.33329 1.66699C4.65139 1.66699 1.66663 4.65176 1.66663 8.33366C1.66663 12.0156 4.65139 15.0003 8.33329 15.0003C9.87389 15.0003 11.2924 14.4778 12.4213 13.6002L16.9107 18.0896C17.2361 18.415 17.7638 18.415 18.0892 18.0896C18.4147 17.7641 18.4147 17.2365 18.0892 16.9111L13.5998 12.4217C14.4774 11.2928 15 9.87425 15 8.33366C15 4.65176 12.0152 1.66699 8.33329 1.66699ZM3.33329 8.33366C3.33329 5.57223 5.57187 3.33366 8.33329 3.33366C11.0947 3.33366 13.3333 5.57223 13.3333 8.33366C13.3333 11.0951 11.0947 13.3337 8.33329 13.3337C5.57187 13.3337 3.33329 11.0951 3.33329 8.33366Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 5C8 3.34315 6.65685 2 5 2C3.34315 2 2 3.34315 2 5C2 6.65685 3.34315 8 5 8C6.65685 8 8 6.65685 8 5ZM9 5C9 5.9243 8.68516 6.77434 8.15869 7.45166L10.8535 10.1465L10.8877 10.1846C11.0479 10.381 11.0366 10.6705 10.8535 10.8535C10.6705 11.0366 10.381 11.0479 10.1846 10.8877L10.1465 10.8535L7.45166 8.15869C6.77434 8.68516 5.9243 9 5 9C2.79086 9 1 7.20914 1 5C1 2.79086 2.79086 1 5 1C7.20914 1 9 2.79086 9 5Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.6667 6.66634C10.6667 4.4572 8.87585 2.66634 6.66671 2.66634C4.45757 2.66634 2.66671 4.4572 2.66671 6.66634C2.66671 8.87548 4.45757 10.6663 6.66671 10.6663C8.87585 10.6663 10.6667 8.87548 10.6667 6.66634ZM12 6.66634C12 7.89874 11.5803 9.03213 10.8783 9.93522L14.4714 13.5283L14.517 13.5791C14.7305 13.841 14.7155 14.227 14.4714 14.471C14.2273 14.7151 13.8413 14.7302 13.5795 14.5166L13.5287 14.471L9.93559 10.8779C9.03249 11.5799 7.89911 11.9997 6.66671 11.9997C3.72119 11.9997 1.33337 9.61186 1.33337 6.66634C1.33337 3.72082 3.72119 1.33301 6.66671 1.33301C9.61223 1.33301 12 3.72082 12 6.66634Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.3334 8.33366C13.3334 5.57223 11.0948 3.33366 8.33342 3.33366C5.57199 3.33366 3.33341 5.57223 3.33341 8.33366C3.33341 11.0951 5.57199 13.3337 8.33342 13.3337C11.0948 13.3337 13.3334 11.0951 13.3334 8.33366ZM15.0001 8.33366C15.0001 9.87416 14.4754 11.2909 13.5979 12.4198L18.0893 16.9111L18.1462 16.9746C18.4132 17.3019 18.3944 17.7844 18.0893 18.0895C17.7842 18.3946 17.3017 18.4134 16.9744 18.1465L16.9109 18.0895L12.4195 13.5981C11.2906 14.4756 9.87391 15.0003 8.33342 15.0003C4.65152 15.0003 1.66675 12.0156 1.66675 8.33366C1.66675 4.65176 4.65152 1.66699 8.33342 1.66699C12.0153 1.66699 15.0001 4.65176 15.0001 8.33366Z" fill="currentColor" />
    </svg>
  );
};

export const variants = createIconVariantMap({
  filled: {
    12: Filled12,
    16: Filled16,
    20: Filled20,
  },
  outlined: {
    12: Outlined12,
    16: Outlined16,
    20: Outlined20,
  },
});

export const IconSearchSm: FC<IconElementProps & { className?: string }> = (props) => (
  <Icon name={"search-sm"} {...props} />
);
